export default {
  route: {
    Student: '学生管理',
    StudentList: '学生列表'
  },

  '学生管理': '学生管理',
  '学生列表': '学生列表',
  '添加学生': '添加学生',
  '请输入学生姓名或学号': '请输入学生姓名或学号',
  '请输入学生姓名、手机号或留言详情': '请输入学生姓名、手机号或留言详情',
  '删除选中': '删除选中',
  '状态': '状态',
  '搜索': '搜索',
  '清空': '清空',
  '启用': '启用',
  '禁用': '禁用',
  '操作': '操作',
  '详情': '详情',
  '删除': '删除',
  '学生详情': '学生详情',

  'ID': 'ID',
  '姓名': '姓名',
  '学号': '学号',
  '年龄': '年龄',
  '性别': '性别',
  '男': '男',
  '女': '女',
  '班级': '班级',
  '手机号': '手机号',
  '邮箱': '邮箱',
  '留言详情': '留言详情',
  '创建时间': '创建时间',
  '时间': '时间',

  '请输入学生姓名': '请输入学生姓名',
  '请输入学号': '请输入学号',
  '请输入学号（可选）': '请输入学号（可选）',
  '请输入年龄': '请输入年龄',
  '请输入班级': '请输入班级',
  '请输入班级（可选）': '请输入班级（可选）',
  '请输入手机号': '请输入手机号',
  '请输入邮箱': '请输入邮箱',
  '请输入邮箱（可选）': '请输入邮箱（可选）',
  '请输入留言详情（可选）': '请输入留言详情（可选）',
  '请输入正确的邮箱格式': '请输入正确的邮箱格式',

  '确认要删除该学生吗？': '确认要删除该学生吗？',
  '确认要删除选中的学生吗？': '确认要删除选中的学生吗？',
  '请选择要删除的学生': '请选择要删除的学生',
  '删除选择的学生成功': '删除选择的学生成功',
  '学生添加成功': '学生添加成功',
  '学生删除成功': '学生删除成功',
  '学生信息不存在': '学生信息不存在',
  '学生ID不能为空': '学生ID不能为空',
  '学生姓名不能为空': '学生姓名不能为空',
  '学号不能为空': '学号不能为空',
  '年龄必须在1-100之间': '年龄必须在1-100之间',
  '手机号不能为空': '手机号不能为空',
  '邮箱不能为空': '邮箱不能为空',

  '取消': '取消',
  '确定': '确定',
  '提示': '提示'
}
